import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function downloadTicketImportTemplate() {
  const res = await axios.get(`${API}/tickets/import/template`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  return res.data;
}

export async function createTicketImportJob({ file, salon_id }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("salon_id", salon_id);
  const res = await axios.post(`${API}/tickets/import/jobs`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function previewTicketImportJob(jobId, payload) {
  const res = await axios.post(
    `${API}/tickets/import/jobs/${jobId}/preview`,
    payload,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
}

export async function commitTicketImportJob(jobId, payload) {
  const res = await axios.post(
    `${API}/tickets/import/jobs/${jobId}/commit`,
    payload,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
}

export async function listTicketImportJobs({ salon_id, page = 1, per_page = 10 }) {
  const res = await axios.get(`${API}/tickets/import/jobs`, {
    params: { salon_id, page, per_page },
    headers: authHeaders(),
  });
  return res.data;
}

export async function getTicketImportJob(jobId) {
  const res = await axios.get(`${API}/tickets/import/jobs/${jobId}`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function rollbackTicketImportJob(jobId) {
  const res = await axios.post(
    `${API}/tickets/import/jobs/${jobId}/rollback`,
    {},
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}
